import { Trans, useTranslation } from 'next-i18next/pages';
import Link from 'next/link';

import { getButtonClassName } from '@pflegia/ui/shared/button';
import ContainerSection from '@pflegia/ui/shared/container-section';

interface CtaBannerProps {
  /** Key inside the `jobBoard` namespace holding `title`, `subtitle` and `cta`. */
  translationPrefix: string;
  href: string;
  className?: string;
}

const CtaBanner: React.FC<CtaBannerProps> = ({ translationPrefix, href, className }) => {
  const { t } = useTranslation('jobBoard', { keyPrefix: translationPrefix });
  const ctaClassName = getButtonClassName('primary', 'w-fit shrink-0 rounded-full px-6 py-3 font-light text-white');

  return (
    <ContainerSection className={className}>
      <div className='bg-extended-jobs-background flex flex-col gap-6 rounded-3xl p-8 lg:flex-row lg:items-center lg:justify-between'>
        <div>
          <h2 className='text-default mb-2 text-2xl font-medium'>
            <Trans components={{ span: <span className='text-primary' /> }} i18nKey='title' t={t} />
          </h2>
          <p className='text-secondary'>{t('subtitle')}</p>
        </div>

        {href.startsWith('#') ? (
          <a className={ctaClassName} href={href}>
            {t('cta')}
          </a>
        ) : (
          <Link className={ctaClassName} href={href}>
            {t('cta')}
          </Link>
        )}
      </div>
    </ContainerSection>
  );
};

export default CtaBanner;
